import {Component} from '@angular/core';
import {Select} from '@ngxs/store';
import {Observable} from 'rxjs';
import {SharedSelectors} from '../../../../state/shared.selector';
import {RouterState} from '@ngxs/router-plugin';
import {NavItem} from '../../../../models/nav-item.model';
import {AuthState} from '../../../../state/auth/auth.state';

@Component({
    selector: 'app-breadcrumbs',
    templateUrl: './breadcrumbs.component.html',
    styleUrls: ['./breadcrumbs.component.less']
})
export class BreadcrumbsComponent {
    @Select(SharedSelectors.getBreadcrumbs(RouterState.state, AuthState.currentUser)) breadcrumbs$: Observable<NavItem[]>;
}
